import React from "react";
import "../../_css/ReviewAns.css";

const AnswerPDF = ({ pdf, fillHeight = false }) => {
  return (
    <div
      className={`review-q-ans-con${
        fillHeight ? " review-q-ans-con--fill" : ""
      }`}
    >
      <div className="review-ans-sheet">
        <iframe
          className={fillHeight ? "review-pdf-iframe--fill" : undefined}
          style={{ border: "none", backgroundColor: "white" }}
          src={`${pdf}#toolbar=0&navpanes=0&view=FitH`}
          width="100%"
          {...(fillHeight ? {} : { height: "715px" })}
          scrolling="no"
          title="Answer sheet PDF"
        />
      </div>
    </div>
  );
};

export default AnswerPDF;